class CosmosTokens {
  setTokens(tokens) {
    this.tokens = tokens;
  }
  getTokens() {
    return this.tokens;
  }
  getStyle() {
    if (!this.tokens)
      return '';
    const cssVariables = Object.entries(this.tokens)
      .map(([token, value]) => `--${token}: ${value};`)
      .join('');
    return `:host {${cssVariables}}`;
  }
}
const cosmosTokens = new CosmosTokens();

export { cosmosTokens as c };

//# sourceMappingURL=cosmos-tokens.js.map